import { Col, Row, Label } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  staffHolidayCalendarCreate,
  staffHolidayCalendarCreateSuccess,
  staffHolidayCalendarList,
  staffHolidayCalendarPeriodCreate,
  staffHolidayCalendarPeriodCreateSuccess,
  staffHolidayCalendarPeriodList,
  staffHolidayCalendarPeriodUpdate,
  staffHolidayCalendarPeriodUpdateSuccess,
  staffHolidayCalendarUpdate,
  staffHolidayCalendarUpdateSuccess,
} from "../../../store/staffLeave/action";
import Select from "../../Common/AppSelect";
import LoadingSpinner from "../../Common/Spinner";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import AppModal from "../../Common/AppModal";
import HandleDateTime, {
  handleDateFormat,
  handleValidDateTime,
} from "../../Common/HandleDateTime";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import moment from "moment";

export default function CreateEditStaffHolidayPeriodConfig({
  modal,
  setModal,
  toggle,
  isEdit,
  updateData,
}) {
  const dispatch = useDispatch();

  const initialData = {
    StaffHolidayCalendar_Id: "",
    StartDate: "",
    EndDate: "",
    DefaultStaffDecisionExpiryDurationMinutes: "4320",
    Notes: "",
  };

  const [data, setData] = useState(initialData);

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(updateData)) return;
    setData({
      Id: updateData?.Id,
      StaffHolidayCalendar_Id: updateData?.StaffHolidayCalendar_Id,
      StartDate: updateData?.StartDate,
      EndDate: updateData?.EndDate,
      DefaultStaffDecisionExpiryDurationMinutes:
        updateData?.DefaultStaffDecisionExpiryDurationMinutes,
      Notes: updateData?.Notes,
    });
  }, [updateData, isEdit]);

  const handleCreateUpdateData = (type) => {
    // check
    // if (isEmpty(data.QtyOfHoursInSingleDay)) {
    //   toast.error("Qty Of Hours In Single Day is required");
    //   return;
    // }
    if (type === "create") {
      dispatch(staffHolidayCalendarPeriodCreate([data]));
    }
    if (type === "update") {
      dispatch(staffHolidayCalendarPeriodUpdate([data]));
    }
  };

  const {
    CreateSUCCESS,
    UpdateSUCCESS,
    staffHolidayCalendarPeriodCreateLoading,
    staffHolidayCalendarPeriodUpdateLoading,
  } = useSelector((state) => ({
    CreateSUCCESS: state.StaffLeave.staffHolidayCalendarPeriodCreate,
    UpdateSUCCESS: state.StaffLeave.staffHolidayCalendarPeriodUpdate,
    staffHolidayCalendarPeriodCreateLoading:
      state.StaffLeave.staffHolidayCalendarPeriodCreateLoading,
    staffHolidayCalendarPeriodUpdateLoading:
      state.StaffLeave.staffHolidayCalendarPeriodUpdateLoading,
  }));

  //Create
  useEffect(() => {
    if (isEmpty(CreateSUCCESS)) return;
    if (CreateSUCCESS.status === 200) {
      toast.success(CreateSUCCESS.message);
      setModal(false);
      dispatch(staffHolidayCalendarPeriodList());
    } else {
      toast.error(CreateSUCCESS.message);
    }
    dispatch(staffHolidayCalendarPeriodCreateSuccess([]));
  }, [CreateSUCCESS]);

  //Update
  useEffect(() => {
    if (isEmpty(UpdateSUCCESS)) return;
    if (UpdateSUCCESS.status === 200) {
      toast.success(UpdateSUCCESS.message);
      setModal(false);
      dispatch(staffHolidayCalendarPeriodList());
    } else {
      toast.error(UpdateSUCCESS.message);
    }
    dispatch(staffHolidayCalendarPeriodUpdateSuccess([]));
  }, [UpdateSUCCESS]);

  const { staffHolidayCalendarListAPI, staffHolidayCalendarPeriodDataLoading } =
    useSelector((state) => ({
      staffHolidayCalendarListAPI:
        state.StaffLeave.staffHolidayCalendarList?.staffholidaycalendar_list,
      staffHolidayCalendarPeriodDataLoading:
        state.StaffLeave.staffHolidayCalendarListLoading,
    }));
  console.log("staffHolidayCalendarListAPI", staffHolidayCalendarListAPI);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={
        isEdit
          ? "Edit Staff Holiday Calendar Period Config"
          : "Create New Period Staff Holiday Calendar"
      }
      icon={<DateRangeOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={
        staffHolidayCalendarPeriodCreateLoading ||
        staffHolidayCalendarPeriodUpdateLoading
      }
      loadingText="Saving…"
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      onSubmit={() =>
        isEdit
          ? handleCreateUpdateData("update")
          : handleCreateUpdateData("create")
      }
    >
      <Row className="g-3">
            <Col lg={12}>
              <div className={"d-flex flex-column p-2"}>
                <Label>Staff Holiday Calendar Config</Label>
                {staffHolidayCalendarPeriodDataLoading ? (
                  <LoadingSpinner />
                ) : (
                  <Select
                    options={staffHolidayCalendarListAPI?.map((item) => ({
                      value: item.Id,
                      label: item.Name,
                    }))}
                    onChange={(e) =>
                      setData({ ...data, StaffHolidayCalendar_Id: e.value })
                    }
                    value={
                      data?.StaffHolidayCalendar_Id
                        ? {
                            value: data?.StaffHolidayCalendar_Id,
                            label: staffHolidayCalendarListAPI?.find(
                              (item) =>
                                item.Id === data?.StaffHolidayCalendar_Id
                            )?.Name,
                          }
                        : ""
                    }
                  ></Select>
                )}
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Start Date</Label>
                <AppDatePicker
                  value={
                    data?.StartDate
                      ? moment(data?.StartDate, "YYYY-MM-DD")
                      : null
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setData({
                      ...data,
                      StartDate: jsDate ? handleDateFormat(jsDate) : "",
                    });
                  }}
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>EndDate Date</Label>
                <AppDatePicker
                  value={
                    data?.EndDate ? moment(data?.EndDate, "YYYY-MM-DD") : null
                  }
                  onChange={(val) => {
                    const jsDate = val && val.isValid() ? val.toDate() : null;
                    setData({
                      ...data,
                      EndDate: jsDate ? handleDateFormat(jsDate) : "",
                    });
                  }}
                />
              </div>
              <div className={"d-flex flex-column p-2"}>
                <Label>Default Staff Decision Expiry Duration Minutes</Label>
                <input
                  type={"text"}
                  className={"form-control"}
                  value={data.DefaultStaffDecisionExpiryDurationMinutes}
                  onChange={(e) =>
                    setData({
                      ...data,
                      DefaultStaffDecisionExpiryDurationMinutes: e.target.value,
                    })
                  }
                />
              </div>{" "}
              <div className={"d-flex flex-column p-2"}>
                <Label>Notes</Label>
                <input
                  type={"text"}
                  className={"form-control"}
                  value={data.Notes}
                  onChange={(e) => setData({ ...data, Notes: e.target.value })}
                />
              </div>
              {/*[*/}
              {/*{*/}
              {/*    "Name": "{{$randomWords}}",*/}
              {/*    "Description": "{{$randomLoremParagraph}}",*/}
              {/*    "FlagAutoOpenUponRenewal": 1,*/}
              {/*    "DaysToOpenNextRenewal": 90,*/}
              {/*    "StartDateDay": 1,*/}
              {/*    "StartDateMonth": 1,*/}
              {/*    "EndDateDay": 31,*/}
              {/*    "EndDateMonth": 12,*/}
              {/*    "QtyOfHoursInSingleDay": 7.5*/}
              {/*}*/}
              {/*]*/}
            </Col>
          </Row>
    </AppModal>
  );
}
